import React from "react";
import './KurumsalPage.scss';
import OBBTvComponent from '../../components/OBBTvComponent';

const sections = [
    { title: "Basın Yayın ve Halkla İlişkiler Dairesi Başkanı", names: ["Mehmet Demirbaş"] },
    { title: "Yayın Koordinatörü", names: ["Tolga Hüsem"] },

    { title: "Yayına Hazırlayanlar", names: ["Erdem Akarsu", "Ebru Poyraz", "A. Adnan Bolaman", "Esra Hüsem"] },
    { title: "Kamera", names: ["Erdem Akarsu", "Osman Demirel"] },
    { title: "Grafik Tasarım", names: ["Cihat Döleş", "Zarife Aykut",  "Merve Bayhan"] },
    { title: "Sosyal Medya", names: ["Ebru Poyraz","Erdi Yağızoğlu"] },
    { title: "Sunucular", names: ["Esra Hüsem", "Ebru Poyraz"] },
    { title: "Yazı İşleri", names: ["Sibel Öztürk", "Betül Demir"] },
    { title: "Ulaşım", names: ["Gündüz Aşçı"] },
    { title: "İzleyici Temsilcisi", names: ["Ümmihan Özcanlı"] },
    { title: "Hukuk Müşaviri", names: ["Burcu Yıldız"] },
    { title: "Erişim Sağlayıcı", names: ["Yayin.com.tr"] }
];

const KurumsalPage = () => {
    return (
        <div className="kurumsal-page">
            <header className="kurumsal-hero">
                <div className="container">
                    <h1 className="kurumsal-title">Kurumsal</h1>
                    <p className="kurumsal-subtitle">Ekip, görev dağılımı ve iletişim bilgileri</p>
                </div>
            </header>

            <main className="kurumsal-content container">
                <section className="kurumsal-card" aria-labelledby="kurumsal-heading">
                    <h2 id="kurumsal-heading" className="visually-hidden">Kurumsal Ekip</h2>

                    <div className="kurumsal-grid">
                        {sections.map((s, i) => (
                            <article key={i} className="kurumsal-item">
                                <h3 className="item-title">{s.title}</h3>
                                <div className="item-names">
                                    {s.names.map((n, idx) => (
                                        <div key={idx} className="name">{n}</div>
                                    ))}
                                </div>
                            </article>
                        ))}
                    </div>

                </section>

                <section className="obbtv-section">
                    <h3 className="obbtv-title">OBB TV</h3>
                    <OBBTvComponent />
                </section>
            </main>
        </div>
    );
};

export default KurumsalPage;
